/**
 * @generated SignedSource<<4d45490d7c55a7cc717372c8c1a220f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginOnelogin_Query$variables = {};
export type loginOnelogin_Query$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"loginOnelogin_viewer">;
  } | null;
};
export type loginOnelogin_Query = {
  variables: loginOnelogin_Query$variables;
  response: loginOnelogin_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_onelogin"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_onelogin\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginOnelogin_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginOnelogin_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0420010c094f3228b1f4ec0ede0adff7",
    "id": null,
    "metadata": {},
    "name": "loginOnelogin_Query",
    "operationKind": "query",
    "text": "query loginOnelogin_Query {\n  viewer {\n    component(name: \"login_onelogin\")\n    ...loginOnelogin_viewer\n    id\n  }\n}\n\nfragment loginOnelogin_viewer on Viewer {\n  id\n  actualPersonId\n}\n"
  }
};
})();

(node as any).hash = "4c7105b30011b23ad0e23b6d0441001c";

export default node;
